<script>
  export default {
    name: "AtomLabel",
    props: {
      text: { type: String, default: "" },
      forId: { type: String, required: true },
      variant: { type: String, default: "primary" },
      styles: { type: Object, default: () => ({}) },
    },
  };
</script>

<template>
  <label :for="forId" :class="['atom-label', `atom-label--${variant}`]" :style="styles">
    <slot>{{ text }}</slot>
  </label>
</template>

<style lang="scss">
  .atom-label {
    font-size: 14px;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    &--primary {
      font-family: $newFont_medium;
      font-size: 16px;
      color: #1f2937;
    }

    &--secondary {
      color: #6b7280;
    }

    &--error {
      color: #dc2626;
    }

    &--success {
      color: #16a34a;
    }
  }
</style>
